module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAACXBIWXMAAAsSAAALEgHS3X78AAABCUlEQVQ4jZ1UURGDMAx9YGA4GBJwMCRUAnOwOdgcIGESkFAJSGAOOgXZhUt3vZAy4N3lJ+1717w8KIgIBhyABkALIAAYpYbFVRZIyhHRRHnwWZtyUvJthajRaYFuBzmijQIVEYUDAjwOSjHspKz5ALgCKKTu0ktxnrlENOSeZxis0fOBV83RIMfSG/KlkYFgBUMw6UZpEDhAlUHm3kX1xtJIFxvaG2RviHqOciVP05t4J+JOXNfndTSnP5CDR5rEeic5SABnEyEjPI0Zc+h/5ic73hrpKfc1bv0i3ZoAJIk5eH3fEmhWjGOz/wpw8Yo0eLzF3ZwAG5qOsnh6rNxPNcaXE8h4mTcAfAEa7j9X51j9RgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/logo/agencia-ic.png
// module id = 231
// module chunks = 0